import React from "react";
import { Flex, Tag } from "antd";
import { DimmedText, H3, HighLightedText } from "./styles/Utilities.styled";
import { Collapse, Highlights } from "./styles/ExperienceSection.styled";
import { StyledMinusIcon, StyledPlusIcon } from "./icons/getIcon";
import getRandomTagColor from "./helpers/getRandomTagColor";
import { FormattedDate, FormattedMessage } from "react-intl";
import profile from "./config/profile";
import messages from "./locales/messages";

const { experiences } = profile;

// "2025-02" -> February 2025, in the visitor's language
const MonthYear = ({ value }) => (
  <FormattedDate value={`${value}-01T12:00:00`} month="long" year="numeric" />
);

const bold = (chunks) => <strong>{chunks}</strong>;

const items = experiences.map(
  ({ id, name, location, title, from, to, tags, highlights }) => ({
    key: id,
    label: (
      <Flex justify="space-between" style={{ fontSize: "2rem" }} wrap>
        <DimmedText>
          <MonthYear value={from} />
          {" – "}
          {to ? (
            <MonthYear value={to} />
          ) : (
            <FormattedMessage {...messages.present} />
          )}
        </DimmedText>
        <H3>
          <FormattedMessage {...title} />
          {" - "} <HighLightedText>{name}</HighLightedText>
        </H3>
      </Flex>
    ),
    children: (
      <Flex vertical gap="1.6rem">
        <DimmedText style={{ fontSize: "1.5rem" }}>{location}</DimmedText>
        <Highlights>
          {highlights.map((highlight) => (
            <li key={highlight.id}>
              <FormattedMessage {...highlight} values={{ b: bold }} />
            </li>
          ))}
        </Highlights>
        {tags && (
          <Flex gap="1rem 0.4rem" wrap>
            {tags.map((tag) => (
              <Tag key={`${tag}-${id}`} color={getRandomTagColor()}>
                {tag}
              </Tag>
            ))}
          </Flex>
        )}
      </Flex>
    ),
  }),
);

const Experiences = () => {
  return (
    <Collapse
      items={items}
      bordered
      ghost
      defaultActiveKey={experiences[0].id}
      expandIconPosition="end"
      expandIcon={({ isActive }) =>
        isActive ? <StyledMinusIcon /> : <StyledPlusIcon />
      }
    />
  );
};

export default Experiences;
